import { isBaccarat, isSicbo } from '@utils/functions';

const DEFAULT_MAX_HISTORY = 10;

/**
 * Limit the history kept in store based on each game type
 * @param {string|number} id
 * @returns {number}
 * @default DEFAULT_MAX_HISTORY
 */
export function getMaxHistoryByGame(id) {
  if (isSicbo(id)) {
    return 1;
  }

  if (isBaccarat(id)) {
    return 26 * 6;
  }

  return DEFAULT_MAX_HISTORY;
}
